import { FC } from "react"
import { Button, Stack, Typography } from "@mui/material"
import { Modal } from "@/core/components"
import { OSINT } from "../interfaces"
import { useActionMutation } from "../store"

interface IProps {
  open: boolean
  query: OSINT.QueryDto | null
  onClose: () => void
}

export const AwaitingInputModal: FC<IProps> = ({ open, query, onClose }) => {
  const [action, { isLoading }] = useActionMutation()

  const handlePress = async (buttonId: string) => {
    if (!query) return
    try {
      await action({
        pathParams: { id: query.id },
        body: { type: "pressButton", buttonId },
      }).unwrap()
      onClose()
    } catch {
      // SnackbarAlert не подключён — оставляем silent fail.
    }
  }

  const handleCancel = async () => {
    if (!query) return
    try {
      await action({
        pathParams: { id: query.id },
        body: { type: "cancel" },
      }).unwrap()
      onClose()
    } catch {
      /* noop */
    }
  }

  const buttons = query?.inlineButtons ?? []
  // Только callback-кнопки имеют смысл для action.pressButton
  // (login_url / web_app — это просто ссылки, юзер открывает их в браузере).
  const callbackButtons = buttons.filter((b) => b.kind === "callback")
  const linkButtons = buttons.filter((b) => b.kind !== "callback")

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Действия по запросу"
      dialogProps={{ maxWidth: "sm" }}
    >
      <Stack spacing={2}>
        {query?.payload && (
          <Typography variant="body2" color="text.secondary">
            Запрос: {JSON.stringify(query.payload)}
          </Typography>
        )}

        {callbackButtons.length > 0 && (
          <Stack spacing={1}>
            <Typography variant="subtitle2">Выбор бота:</Typography>
            {callbackButtons.map((b) => (
              <Button
                key={b.id}
                variant="outlined"
                disabled={isLoading}
                onClick={() => handlePress(b.id)}
              >
                {b.text}
              </Button>
            ))}
          </Stack>
        )}

        {linkButtons.length > 0 && (
          <Stack spacing={1}>
            <Typography variant="subtitle2">Ссылки:</Typography>
            {linkButtons.map((b) => (
              <Button
                key={b.id}
                variant="text"
                component="a"
                href={b.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {b.text}
              </Button>
            ))}
          </Stack>
        )}

        <Button color="error" onClick={handleCancel} disabled={isLoading}>
          Отменить запрос
        </Button>
      </Stack>
    </Modal>
  )
}
